import { apiDelete, apiGet, apiPost } from '@/shared/utils/requestBuilder';
import type {
  ConvidarMembroDto,
  EscritorioConvite,
  ListarConvitesFilters,
  PapelEscritorio,
} from '@/types/escritorio/escritorioTypes';

export const escritorioConvitesService = {
  convidar: async (escritorioId: string, data: ConvidarMembroDto): Promise<EscritorioConvite> => {
    const response = await apiPost(`/convites-escritorio/escritorio/${escritorioId}`, data);

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(errorData?.error?.message || 'Erro ao enviar convite');
    }

    const result = await response.json();
    return result.data;
  },

  convidarComSetores: async (
    escritorioId: string,
    data: {
      email: string;
      papel: Exclude<PapelEscritorio, 'MASTER_ADMIN'>;
      setorIds: string[];
      observacoes?: string;
      nomeConvidado?: string;
    },
  ): Promise<{ convites: EscritorioConvite[]; totalEnviados: number }> => {
    const response = await apiPost(
      `/convites-escritorio/escritorio/${escritorioId}/com-setores`,
      data,
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(errorData?.error?.message || 'Erro ao enviar convite');
    }

    const result = await response.json();
    return result.data;
  },

  listar: async (
    escritorioId: string,
    filters?: ListarConvitesFilters,
  ): Promise<EscritorioConvite[]> => {
    try {
      const params = new URLSearchParams();
      if (filters?.usado !== undefined) params.append('usado', String(filters.usado));
      if (filters?.cancelado !== undefined) params.append('cancelado', String(filters.cancelado));

      const query = params.toString() ? `?${params.toString()}` : '';
      const endpoint = `/convites-escritorio/escritorio/${escritorioId}${query}`;

      console.log('🔍 Requisitando convites:', endpoint);
      const response = await apiGet(endpoint);

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        console.error('❌ Erro na resposta ao listar convites:', {
          status: response.status,
          errorData,
        });
        throw new Error(errorData?.error?.message || 'Erro ao listar convites');
      }

      const data = await response.json();
      console.log('✅ Convites listados com sucesso:', data.data?.length || 0);
      return data.data;
    } catch (error) {
      console.error('❌ Exceção ao listar convites:', error);
      throw error;
    }
  },

  aceitar: async (
    token: string,
  ): Promise<{ success: boolean; escritorio: { id: string; nomeFantasia: string } }> => {
    const response = await apiPost(`/convites-escritorio/${token}/aceitar`, {});

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(errorData?.error?.message || 'Erro ao aceitar convite');
    }

    const data = await response.json();
    return data.data;
  },

  buscarPorToken: async (token: string): Promise<EscritorioConvite> => {
    const response = await apiGet(`/convites-escritorio/${token}`, undefined, true);

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(errorData?.error?.message || 'Erro ao buscar convite');
    }

    const data = await response.json();
    return data.data;
  },

  cancelar: async (escritorioId: string, conviteId: string): Promise<void> => {
    const response = await apiDelete(
      `/convites-escritorio/escritorio/${escritorioId}/${conviteId}`,
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(errorData?.error?.message || 'Erro ao cancelar convite');
    }
  },
};
